/**
 * Payment API endpoint constants.
 */
export const PAYMENT_ENDPOINTS = {
    INITIATE_CHECKOUT: '/payment/checkout',
    GET_SUBSCRIPTION_DETAILS: '/payment/subscription-details',
    CANCEL_SUBSCRIPTION: '/payment/subscription/cancel',
};
//# sourceMappingURL=endpoints.js.map